import React from 'react';
import { Box, Typography } from '@mui/material';

function FooterApp() {
    return (
        <Box
            component="footer"
            sx={{
                py: 2,
                px: 2,
                mt: 'auto',
                textAlign: 'center',
            }}
        >
            <Typography variant="body2" color="text.secondary">
                © {new Date().getFullYear()} Excelsior Metrologia. All rights reserved.
            </Typography>
        </Box>
    );
}

export default FooterApp;